import React from 'react'
import { Modal } from '@mui/material'
import ModalCanvas from './ModalCanvas'
import { useFraudIndicators } from '../../FraudIndicatorsProvider'
import { useIntl } from 'react-intl'
import intl from 'localization/components'

const SaveModal = () => {
  const { isSaveModalOpen: isOpen, setIsSaveModalOpen: setIsOpen } = useFraudIndicators()
  const reactIntl = useIntl()
  return (
    <Modal open={isOpen} onClose={() => setIsOpen(false)} closeAfterTransition>
      <ModalCanvas
        title={reactIntl.formatMessage({
          id: intl.fraudIndicators('save_modal_title'),
        })}
        text={reactIntl.formatMessage({
          id: intl.fraudIndicators('save_modal_text'),
        })}
        primaryBtnTitle={reactIntl.formatMessage({
          id: intl.generic('save_changes'),
        })}
        secondaryBtnTitle={reactIntl.formatMessage({
          id: intl.generic('discard'),
        })}
        primaryBtnFunc={() => {
          // TODO: implement save functionality
          setIsOpen(false)
        }}
        secondaryBtnFunc={() => {
          // TODO: implement discard functionality
          setIsOpen(false)
        }}
        closeFn={() => setIsOpen(false)}
      />
    </Modal>
  )
}

export default SaveModal
